import { UserFeatureFlag } from '@@types/api.types';
import { ReportLayout } from '@components/layouts/report.layout';
import { HelmetWrapper } from '@components/shared/helmet.component';
// import { INSIGHTS_VIEWPORT_ANCHOR_ID } from '@components/shared/insights-iframe-manager.component';
import { PageviewTracker } from '@components/shared/pageview-tracker.component';
import { useGetCurrentUser } from '@queries/users.query';
import { routes } from '@routes';
import React from 'react';
import { Navigate } from 'react-router-dom';

export const InsightsPage: React.FC = () => {
  const { data: user, isPending } = useGetCurrentUser();
  const hasInsightsTool = user?.featureFlags?.includes(UserFeatureFlag.INSIGHTS_TOOL);

  if (!isPending && !hasInsightsTool) {
    return <Navigate to={routes.home.path} />;
  }

  return (
    <PageviewTracker>
      <HelmetWrapper title="Insights" />
      <ReportLayout>
        <div />
        {/* <Tile isLoading={isPending}>
         <div
            className="h-[calc(100svh-var(--impersonation-banner-height,0px)-4rem)]"
            id={INSIGHTS_VIEWPORT_ANCHOR_ID}
          />
        </Tile> */}
      </ReportLayout>
    </PageviewTracker>
  );
};
